import { signIn } from "aws-amplify/auth";
import { authBus } from "../AuthEvents";

export const login = async (email: string, password: string): Promise<void> => {
  try {
    const { isSignedIn, nextStep } = await signIn({ username: email, password });

    if (isSignedIn) {
      authBus.emitTransition("authenticated");
      if (typeof window !== "undefined") (window as any)?.plausible?.("User-Login");
    } else {
      // Handle cases like 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED'
      // or 'CONFIRM_SIGN_UP'
      console.log("Next step required:", nextStep.signInStep);

      if (nextStep.signInStep === "CONFIRM_SIGN_UP") {
        authBus.emitMessage("Please confirm your email before signing in.  Please enter the code sent to your email.", "error");
        authBus.emitTransition("get-email-confirmation");
      }
    }
  } catch (error: any) {
    let userMessage = "An error occurred during login. Please try again.";

    // Amplify v6 uses error.name for these specific Cognito codes
    switch (error.name) {
      case "UserNotFoundException": {
        userMessage = "User not found. Confirm email address or register for an account.";
        break;
      }
      case "UserAlreadyAuthenticatedException": {
        authBus.emitTransition("authenticated");
        return;
      }
      case "NotAuthorizedException": {
        userMessage = "Incorrect email or password. Please try again.";
        break;
      }
      case "UserNotConfirmedException":
        userMessage = "Email not confirmed. Please check your inbox.";
        authBus.emitTransition("get-email-confirmation");
        break;
      case "LimitExceededException":
      case "TooManyRequestsException":
        userMessage = "Too many attempts. Please try again later.";
        break;
      default:
        userMessage = error.message || userMessage;
        break;
    }

    authBus.emitMessage(userMessage, "error");
  }
};
